import React from "react";

const sections = [
  {
    title: "1. Responsable du traitement",
    body: "Hecnos SAS, dont le siège est situé 10 Av. du Stade de France, 93210 Saint-Denis (France), agit en qualité de responsable du traitement des données personnelles collectées via ce site. Contact : hello@hecnos.fr — +33 6 99 29 21 71.",
  },
  {
    title: "2. Données collectées",
    body: "Nous collectons uniquement les données nécessaires : nom, email, téléphone, entreprise et message via le formulaire de contact, ainsi que des données techniques (logs, cookies fonctionnels) pour la sécurité et l'amélioration du service.",
  },
  {
    title: "3. Finalités du traitement",
    body: "Vos données sont traitées pour : (i) répondre à vos demandes de contact, (ii) traiter les candidatures spontanées, (iii) améliorer la qualité de notre service, (iv) respecter nos obligations légales. Aucune décision automatisée n'est appliquée.",
  },
  {
    title: "4. Base légale (RGPD)",
    body: "Le traitement repose sur votre consentement (art. 6.1.a RGPD) pour les communications, l'exécution de mesures précontractuelles (art. 6.1.b) pour les demandes commerciales, et notre intérêt légitime (art. 6.1.f) pour la sécurité du site.",
  },
  {
    title: "5. Durée de conservation",
    body: "Les données de contact sont conservées 3 ans après le dernier échange. Les candidatures sont conservées 2 ans. Les logs techniques sont conservés 12 mois maximum.",
  },
  {
    title: "6. Destinataires",
    body: "Vos données ne sont accessibles qu'aux équipes habilitées de Hecnos SAS et à ses sous-traitants techniques (hébergement, messagerie), tous situés dans l'UE ou bénéficiant d'un cadre de transfert conforme au RGPD.",
  },
  {
    title: "7. Vos droits",
    body: "Conformément au RGPD, vous disposez des droits suivants : accès, rectification, effacement, limitation, portabilité, opposition et retrait du consentement à tout moment. Vous pouvez les exercer en écrivant à hello@hecnos.fr. Vous pouvez également déposer une réclamation auprès de la CNIL (www.cnil.fr).",
  },
  {
    title: "8. Cookies",
    body: "Le site utilise uniquement des cookies strictement nécessaires (préférence de langue) et des cookies de mesure d'audience anonymisée. Aucun cookie publicitaire n'est déposé.",
  },
  {
    title: "9. Sécurité",
    body: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées (chiffrement TLS, contrôles d'accès, journalisation) pour protéger vos données contre tout accès, altération ou divulgation non autorisés.",
  },
];

const Privacy = () => (
  <div data-testid="privacy-page" className="max-w-4xl mx-auto px-6 lg:px-10 pt-16 pb-28">
    <div className="text-xs mono uppercase tracking-[0.3em] text-[#1093f0] mb-4">RGPD</div>
    <h1 className="text-5xl lg:text-6xl font-semibold text-[#131517] leading-[1.05] mb-6">
      Politique de confidentialité
    </h1>
    <p className="text-lg text-[#3f444b] mb-12">
      Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long" })}.
    </p>
    <div className="space-y-10">
      {sections.map((s) => (
        <section key={s.title}>
          <h2 className="text-2xl font-semibold text-[#131517] mb-3">{s.title}</h2>
          <p className="text-[#3f444b] leading-relaxed">{s.body}</p>
        </section>
      ))}
    </div>
  </div>
);

export default Privacy;
